import { render, staticRenderFns } from "./TopNotice.vue?vue&type=template&id=ffb9358a&scoped=true"
import script from "./TopNotice.vue?vue&type=script&lang=js"
export * from "./TopNotice.vue?vue&type=script&lang=js"
import style0 from "./TopNotice.vue?vue&type=style&index=0&id=ffb9358a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffb9358a",
  null
  
)

export default component.exports